import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const Painting = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my painting business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps painting businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for painting businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most painting businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my painting business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like painting. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Painting - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Painting CRM", url: "/industries/painting" }
  ];

  const industryData = {
    name: 'Painting Contractor',
    title: 'Stop Losing Estimate Leads & Book Your Crew 8 Weeks Out',
    subtitle: 'Automate estimate follow-ups, manage project schedules, and get more referrals from happy customers',
    icon: '🎨',
    challenges: [
      'Estimates go cold while crew is busy',
      'Hard to schedule around weather',
      'Customers ghost after initial contact',
      'Difficult to get paid on time',
      'Seasonal revenue fluctuations'
    ],
    solutions: [
      'Automated estimate follow-up sequences',
      'Weather-based scheduling alerts',
      'No-response re-engagement campaigns',
      'Progress payment automation',
      'Interior/commercial winter upsells'
    ],
    features: [
      'Lead CRM with estimate tracking',
      'Automated follow-up sequences',
      'Project scheduling',
      'Weather notifications',
      'Progress payment tracking',
      'Before/after galleries',
      'Color consultation booking',
      'Review automation'
    ],
    results: [
      '50% more estimates convert',
      'Booked 8+ weeks in advance',
      '40% increase in referrals',
      '£9.2K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Painting UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for painting businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for painting UK, painting business software, painting customer management, painting lead generation UK"
        url="/industries/painting"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default Painting;